import { registerPlugin } from '@capacitor/core';
const Sunmi = registerPlugin('SunmiPlugin');
export { Sunmi };
//# sourceMappingURL=index.js.map